// extracted by mini-css-extract-plugin
export default {"container":"Samoodbrana_container__nyG1w"};